import { Config } from "@pretty-green/common";
import apiClient from "utils/api";

export default {
    getConfig: async (): Promise<Config> => {
        const { data } = await apiClient.get("/config");
        return data as Config;
    },
};
